import React, { createContext, ReactNode, useEffect, useState } from "react";
import { FORECAST_URI } from "../pages/components/ShipmentMonthTables/ShipmentMonthTables.constants";
import { useLocation } from "react-router-dom";
import useClient from "../hooks/useClient";
import { useParams } from "react-router";
import useQueryParams from "../hooks/useQueryParams";

export type ForecastResponse = {
  data: {
    at_once: Array<Array<number>>;
    dist_method: Array<Array<number>>;
    futures: Array<Array<number>>;
    history?: Array<Array<number>>;
    history_pg2n_totals: Array<Array<number>>;
    futures_pg2n_totals: Array<Array<number>>;
    history_LR_totals?: Array<number>;
  };
  status: string;
  task_status_data: {}
};
const DEFAULT_FORECAST: ForecastResponse = {
  data: {
    at_once: [[0]],
    dist_method: [[0]],
    futures: [[0]],
    history: [[0]],
    history_pg2n_totals: [[0]],
    futures_pg2n_totals: [[0]],
    history_LR_totals: [0],
  },
  status: "base",
  task_status_data: {}
};
export const ForecastContext = createContext<{
  originalForecast: ForecastResponse["data"];
  setOriginalForecast: (val) => void;
  status: string;
  loading: boolean;
  setStatus: (status: string) => void;
  task_status_data: {};
  set_task_status_data: (val) => void;
}>({
  originalForecast: DEFAULT_FORECAST["data"],
  setOriginalForecast: (val) => val,
  loading: false,
  status: "base",
  setStatus: (val) => val,
  task_status_data: {},
  set_task_status_data: (val) => val,
});
const ForecastProvider = ({ children }: { children: ReactNode }) => {
  const { fetchWithAuth } = useClient();
  const { tab } = useParams<{ tab: string }>();
  const { createShipmentSubmitQueryParams } = useQueryParams();
  const { pathname, search } = useLocation();
  const [loading, setLoading] = useState(true);
  const [originalForecast, setOriginalForecast] =
    React.useState<ForecastResponse>(DEFAULT_FORECAST);
  const [status, setStatus] = useState<string>("base");
  const [task_status_data, set_task_status_data] = useState<{ [key: string]: any } >({}); // TODO: declare proper task_status type?

  const [currentLocation, setCurrentLocation] = useState("");
  const [currentSearch, setCurrentSearch] = useState("");
  useEffect(() => {
    if (pathname !== currentLocation || search !== currentSearch) {
      getForecasts().then((data) => {
        if (data !== DEFAULT_FORECAST) {
          setLoading(false);
          setOriginalForecast(data);
          setStatus(data["status"]);
          set_task_status_data(data["task_status_data"]);
        }
      });
      setLoading(true);
      setCurrentLocation(pathname);
      setCurrentSearch(search);
    }
  }, [pathname, search]);

  const getForecasts = async () => {
    const queryParams = createShipmentSubmitQueryParams(tab);
    if (!queryParams.includes("country")) {
      return DEFAULT_FORECAST;
    }
    return await fetchWithAuth<ForecastResponse>(
      `${FORECAST_URI}${queryParams}`,
      (text: string) => console.warn(text),
    );
  };
  return (
    <ForecastContext.Provider
      value={{
        originalForecast: originalForecast["data"],
        status,
        setStatus,
        setOriginalForecast,
        loading,
        task_status_data,
        set_task_status_data,
      }}
    >
      {children}
    </ForecastContext.Provider>
  );
};

export default ForecastProvider;
